module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec10_3adecd031db26ee4011992c33d7165a9.jpg";